import MainLayout from "Layouts/Main";
import Stepper from "Components/Stepper";
import { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAssessmentJourney } from "../../../../Redux/Slices/User/userSlice";
import BackArrow from "../../../../Assets/Svg/Auth/BackArrow.svg";
import "./styles.scss";
import { capitalizeFirstLetter } from "Services/Utils/commonServices";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function AssessmentJourney() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { assessmentId } = useParams();

  //To get params
  const location = useLocation();
  const queryParams = new URLSearchParams(location.state);
  const assessmentName = queryParams.get("assessmentName");

  const [journeyData, setJourneyData] = useState([]);
  const [assessmentDetails, setAssessmentDetails] = useState({});
  const isLoading = useSelector((state) => state.user.isLoading);

  useEffect(() => {
    dispatch(
      getAssessmentJourney({
        assessmentId: assessmentId,
        callBack: setJourneyDetails,
      })
    );
  }, []);
  const setJourneyDetails = (value) => {
    setAssessmentDetails(value);
    setJourneyData(value?.journey);
  };
  return (
    <MainLayout>
      <div className="assessment-journey-container">
        <div className="d-flex align-items-center">
          <img
            src={BackArrow}
            alt="backarrow"
            width="25px"
            height="23px"
            onClick={() => navigate(-1)}
            style={{
              marginLeft: "-10px",
              cursor: "pointer",
            }}
          />
          <h2 className="journey-title ms-2">
          {isLoading === 'loading' ? (
              <Skeleton width={200} height={30} />
            ) : (
              <>
                {capitalizeFirstLetter(assessmentName)}
                &nbsp;-&nbsp;
                {assessmentDetails.submitted_date
                  ? new Date(
                      assessmentDetails?.submitted_date
                    ).toLocaleDateString("en-GB", {
                      month: "short", // Month in letters
                      year: "numeric", // Year in numbers
                    })
                  : "-"}
              </>
            )}
          </h2>
        </div>

        <div className="journey-card">
          <h4>Assessment Details</h4>
          <div className="journey-card-info-1">
            <p>
              Submitted Date:&nbsp;{" "}
              {isLoading === 'loading' ? (
                <Skeleton width={100} />
              ) : (
                <strong>
                  {assessmentDetails.submitted_date
                    ? new Date(
                        assessmentDetails?.submitted_date
                      ).toLocaleDateString("en-GB")
                    : "-"}
                </strong>
              )}
            </p>
            <p>
              Submitted By:&nbsp;{" "}
              {isLoading === 'loading' ? (
                <Skeleton width={150} />
              ) : (
                <strong>{assessmentDetails?.submitted_by || "-"}</strong>
              )}
            </p>
          </div>
          <div className="journey-card-info-1">
            <p>
              KG Assessor:&nbsp;{" "}
              {isLoading  === 'loading'? (
                <Skeleton width={150} />
              ) : (
                <strong>{assessmentDetails?.assessor_name || "-"}</strong>
              )}
            </p>
          </div>
        </div>

        <div className="journey-container">
          <h4>Journey</h4>
          <Stepper steps={journeyData} />
        </div>
      </div>
    </MainLayout>
  );
}

export default AssessmentJourney;
